<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
export default {
  name: 'app'
}
Vue.filter('datefmt', function (input, fmtstring) {
  return moment(input).format(fmtstring);
});
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
  width: 100%;
  height:100%;
}
html,body{
  width: 100%;
  height:100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue